module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Bag#2-14c7e944b87044fe35a1a598261ed844.svg";